export const ReceivementType = {
  CASH: { id: 1, name: "Cash" },
  CARD: { id: 2, name: "Cartão" },
};



// WEBPACK FOOTER //
// ./src/enums/ReceivementType.js